import React from 'react'

import LetterLanding from '../LetterLanding';

import logo_target from '../../../images/letterfunnel/qrconnect.webp';
import screenshot_target from '../../../images/letterfunnel/merlijndevroe.webp';


export default class extends React.Component {

  // variable "competition" is optional, fallback: "jouw B2B concurrenten".
  render() {
    return <LetterLanding
      fullname="Merlijn de Vroe"
      firstname="Merlijn"
      companyname="QR Connect"
      competition="Uniqode en MaintainX"
      logo_target={logo_target}
      screenshot_target={screenshot_target}
    />;
  }

}



// WEBPACK FOOTER //
// ./src/containers/letterfunnel/landings/merlijndevroe.js